<template>
  <div class="selectBox">
    <div>
      课程选择：
      <el-select v-model="formData.courseId" placeholder="请选择" :size="size" @change="courseChange" filterable>
        <el-option
          v-for="item in courseScope"
          :key="item.id"
          :label="item.courseName"
          :value="item.id">
          <template v-if="item.authStatus == 2">
            <span><span style="color: #ed9347">【授权过期】</span> {{ item.courseName }}</span>
          </template>
        </el-option>
      </el-select>
    </div>
    <div v-if="showTeacherSelect">
      老师选择：
      <el-select v-model="teacherId" placeholder="全部老师" :size="size" @change="teacherChange" filterable>
        <el-option
          key=""
          label="全部老师"
          value="">
        </el-option>
        <el-option
          v-for="item in teacherList"
          :key="item.userId"
          :label="item.name"
          :value="item.userId">
        </el-option>
      </el-select>
    </div>
    <div>
      数据时间：
      <el-date-picker
        v-model="dates"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :size="size"
        @change="dateChange"
        :clearable="false">
      </el-date-picker>
    </div>
    <div>
      班级选择：
      <el-select v-model="formData.classId" placeholder="全部班级" :size="size" @change="classChange" filterable>
        <el-option
          key=""
          label="全部班级"
          value="">
        </el-option>
        <el-option
          v-for="item in dataRange"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import {
  classFindByUserType,
  courseFindByUserType,
  findClassScope,
  findCourseScope,
  queryTeacherInCourse
} from "@/api/PostUrl";

export default {
  name: "mSelects",
  props: {
    size: {
      type: String,
      default: 'mini'
    },
    showTeacherSelect: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    defaultFormData(val) {
      Object.assign(this.formData, val)
    }
  },
  data() {
    return {
      userType: sessionStorage.getItem('userType'),
      dataRange: [],
      courseScope: [],
      teacherList: [],
      dates: [],//时间数组
      teacherId: '',
      studentType: '2',
      formData: {
        classId: '',
        courseId: '',//courseId
        startDate: '',
        endDate: '',
      }
    }
  },
  mounted() {
    this.initFun()
  },
  methods: {
    async initFun() {
      const date = await new Date()._$getServerTime()
      const startDate = this.formData.startDate = date._$skipTime(0, -6)._$formatDate(date._$formats.enAsDate)
      const endDate = this.formData.endDate = date._$formatDate(date._$formats.enAsDate)
      this.dates = [startDate, endDate]

      if (String(this.userType) !== this.studentType) {//不是学生
        await this.courseFindByUserType()
        await this.getTeacherList()
      } else {//如果是学生
        await this.findCourseScope()
      }
      this.dateChange()
    },
    //获取课程范围
    async courseFindByUserType() {
      courseFindByUserType.params.type = this.userType
      const data = await this.$apiPost.httpPostForMap(courseFindByUserType)
      this.setCourseScope(data || [])
    },
    //获取数据范围
    async classFindByUserType() {
      classFindByUserType.params.type = this.userType
      classFindByUserType.params.courseId = this.formData.courseId
      classFindByUserType.params.startDate = this.formData.startDate
      classFindByUserType.params.endDate = this.formData.endDate
      classFindByUserType.params.userId = this.formData.userId
      const data = await this.$apiPost.httpPostForMap(classFindByUserType)
      this.dataRange = data || []
    },
    //获取教师列表
    async getTeacherList() {
      if (!this.showTeacherSelect) return
      this.formData.userId = this.teacherId = ''
      queryTeacherInCourse.params.courseId = this.formData.courseId
      const data = await this.$apiPost.httpPostForMap(queryTeacherInCourse)
      this.teacherList = data || []
    },
    //获取学生课程范围
    async findCourseScope() {
      const data = await this.$apiPost.httpPostForMap(findCourseScope)
      this.setCourseScope(data || [])
    },
    setCourseScope(data) {
      this.courseScope = data
      const courseScope0 = this.courseScope[0]
      this.formData.courseId = courseScope0 ? courseScope0.id : ''//设置默认选中第一个
    },
    //获取学生数据范围
    async findClassScope() {
      findClassScope.params.courseId = this.formData.courseId
      findClassScope.params.startDate = this.formData.startDate
      findClassScope.params.endDate = this.formData.endDate
      const data = await this.$apiPost.httpPostForMap(findClassScope)
      this.dataRange = data || []
    },
    async courseChange() {
      this.formData.classId = ''
      this.$emit('courseChange', this.formData)
      await this.getTeacherList()
      await this.selectChange()
    },
    dateChange() {
      this.formData.classId = ''
      this.formData.startDate = this.dates[0]
      this.formData.endDate = this.dates[1]
      this.selectChange()
    },
    classChange() {
      this.selectChange(true)
    },
    teacherChange() {
      this.formData.userId = this.teacherId
      this.formData.classId = ''
      this.selectChange()
    },
    async selectChange(isClassChange) {
      if (!this.courseScope || !this.courseScope.length) {
        throw new Error('课程不存在')
      }
      if (String(this.userType) !== this.studentType) {//不是学生
        !isClassChange && await this.classFindByUserType()
      } else { //是学生
        !isClassChange && await this.findClassScope()
      }
      this.$emit('change', this.formData)
    }
  }
}
</script>

<style scoped lang="scss">
.selectBox {
  flex: 1;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  height: 100%;
  width: 100%;

  & > div {
    margin-left: 10px;
    font-size: 14px;
    white-space: nowrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_account_settings/accountSettings/overallStatistics/components/mSelects.vue